import request from '@/utils/request'

export const translate = (data: any) =>
  request({
    method: 'post',
    url: '/api/translator/translate',
    data
  })
